import { render, staticRenderFns } from "./DateTimeField.vue?vue&type=template&id=b36e804c&lang=pug&"
import script from "./DateTimeField.vue?vue&type=script&lang=ts&"
export * from "./DateTimeField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports